const _state = {
  snapshot: null,
}
const _getters = {
  snapshot: (state) => state.snapshot,
}
const mutations = {
  SET_SNAPSHOT(state, snapshot) {
    state.snapshot = snapshot
  },
}

const actions = {
  setSnapshotAction({ commit, rootState }, { slideId }) {
    const slideNeedSnapshot = rootState.presentation.slides.find((slide) => slide.id === slideId)
    const snapshot = JSON.parse(JSON.stringify(slideNeedSnapshot))
    commit('SET_SNAPSHOT', snapshot)
  },
}
export default {
  namespaced: true,
  state: _state,
  actions,
  getters: _getters,
  mutations,
}
